export const ERROR_CODE_MAP: { [key: string]: string } = {
  'AAA-G001': 'ERR_RMA_NOT_FOUND',
  'AAA-G002': 'ERR_MODEL_INFO_NOT_FOUND',
  'AAA-G003': 'ERR_RMA_DISPLAY_UNAUTHORIZED',
  'AAA-P001': 'ERR_RMA_EXIST',
  'AAA-P002': 'ERR_TEMPLATE_ORGANIZATION_NOT_FOUND',
  'AAA-P003': 'ERR_TEMPLATE_TARGET_NOT_FOUND',
  'AAA-P004': 'ERR_RMA_NOT_FOUND',
  'AAB-G001': 'ERR_SORT_INCORRECT_COLUMN',
  'BAA-G001': 'ERR_RMA_NOT_FOUND',
  'BAA-G002': 'ERR_RMA_ORGANIZATION_NOT_FOUND',
  'BAA-G003': 'ERR_AREA_MODEL_NOT_FOUND',
  'BAA-U001': 'ERR_RMA_NOT_FOUND',
  'BAA-U002': 'ERR_RMA_TEMPLATE_TARGET_NOT_FOUND',
  'BAA-U003': 'ERR_MODEL_NOT_FOUND',
  'BAA-U004': 'ERR_CREATE_INCORRECT_ITEM_TARGET',
  'BAA-U005': 'ERR_INSPECTION_CREATE_ITEM_NOT_FOUND',
  'BAB-G001': 'ERR_RMA_NOT_FOUND',
  'BAC-G001': 'ERR_RMA_NOT_FOUND',
  'BAC-U001': 'ERR_RMA_NOT_FOUND',
  'BBA-G001': 'ERR_RMA_NOT_FOUND',
  'BBA-G002': 'ERR_GET_REPAIR_TYPE',
  'BBA-G003': 'ERR_GET_SERVICE_TYPE',
  'BBA-G004': 'ERR_INSPECTION_ITEM_INCORRECT',
  'BBA-G005': 'ERR_GET_CD_CODE',
  'BBA-U001': 'ERR_RMA_NOT_FOUND',
  'BCA-G001': 'ERR_RMA_NOT_FOUND',
  'BCA-G002': 'ERR_RMA_ORGANIZATION_NOT_FOUND',
  'DAA-G001': 'ERR_SORT_INCORRECT_COLUMN',
  'DAA-U001': 'ERR_USER_UPDATE_NOT_FOUND',
  'DAA-U002': 'ERR_USER_UNAUTHORIZED',
  'DAA-P001': 'ERR_USER_EXIST',
  'DAA-D001': 'ERR_USER_DELETE_NOT_FOUND',
  'DBA-U001': 'ERR_CATEGORY_PUT_NOT_FOUND',
  'DBA-U002': 'ERR_CATEGORY_PUT_UNAUTHORIZED',
  'DBA-P001': 'ERR_CATEGORY_POST_UNAUTHORIZED',
  'DBA-P002': 'ERR_CATEGORY_EXIST',
  'DBA-D001': 'ERR_CATEGORY_DELETE_UNAUTHORIZED',
  'DBA-D002': 'ERR_CATEGORY_DELETE_NOT_FOUND',
  'DCA-U001': 'ERR_TYPE_PUT_NOT_FOUND',
  'DCA-U002': 'ERR_TYPE_PUT_UNAUTHORIZED',
  'DCA-P001': 'ERR_TYPE_POST_UNAUTHORIZED',
  'DCA-P002': 'ERR_TYPE_EXIST',
  'DCA-D001': 'ERR_TYPE_DELETE_AUTHORIZED',
  'DCA-D002': 'ERR_TYPE_DELETE_NOT_FOUND',
  'DDA-U001': 'ERR_ITEM_PUT_NOT_FOUND',
  'DDA-U002': 'ERR_ITEM_PUT_UNAUTHORIZED',
  'DDA-P001': 'ERR_ITEM_POST_UNAUTHORIZED',
  'DDA-P002': 'ERR_ITEM_EXIST',
  'DDA-D001': 'ERR_ITEM_DELETE_UNAUTHORIZED',
  'DDA-D002': 'ERR_ITEM_DELETE_NOT_FOUND',
  'BDA-G001': 'ERR_RMA_NOT_FOUND',
  'DEA-U001': 'ERR_UNAUTHORIZED_ORGANIZATION',
  'DEA-U002': 'ERR_TEMPLATE_NOT_FOUND',
  'DEA-D001': 'ERR_TEMPLATE_DELETE_NOT_FOUND',
  'ABA-U001': 'ERR_RMA_NOT_FOUND',
  'ABA-U002': 'ERR_STATUS_UNAUTHORIZED',
  'ABA-U003': 'ERR_QC_NOT_FOUND',
  'CAA-G001': 'ERR_RMA_NOT_FOUND',
  'CAA-G002': 'ERR_RMA_ORGANIZATION_NOT_FOUND',
  'CAA-G003': 'ERR_AREA_MODEL_NOT_FOUND',
  'CAA-U001': 'ERR_RMA_NOT_FOUND',
  'CAA-U002': 'ERR_RMA_TEMPLATE_NOT_FOUND',
  'CAA-U003': 'ERR_MODEL_NOT_FOUND',
  'CAA-U004': 'ERR_CREATE_INCORRECT_ITEM',
  'CAA-U005': 'ERR_INSPECTION_ITEM_NOT_FOUND',
  'CAB-G001': 'ERR_RMA_NOT_FOUND',
  'CAC-G001': 'ERR_RMA_NOT_FOUND',
  'CAC-U001': 'ERR_RMA_NOT_FOUND',
  'CBA-G001': 'ERR_RMA_NOT_FOUND',
  'CCA-G001': 'ERR_RMA_NOT_FOUND',
  'ACA-G001': 'ERR_RMA_NOT_FOUND',
  'ACA-G002': 'ERR_RMA_TEMPLATE_TARGET_INSPECTION_NOT_FOUND',
  'ACA-G003': 'ERR_RMA_TEMPLATE_TARGET_QC_NOT_FOUND',
  'CAD-G001': 'ERR_RMA_NOT_FOUND',
  'DGA-G001': 'ERR_ORGANIZATION_GET_UNAUTHORIZED',
  'DGA-U001': 'ERR_ORGANIZATION_PUT_UNAUTHORIZED',
  'DGA-U002': 'ERR_SET_OWN_ORGANIZATION',
  'DGA-P001': 'ERR_ORGANIZATION_EXIST',
  'DGA-P002': 'ERR_SET_OWN_ORGANIZATION',
  'DGA-D001': 'ERR_ORGANIZATION_DELETE_UNAUTHORIZED',
  'DGA-D002': 'ERR_ORGANIZATION_DELETE_EXIST_CHILD',
  'DGA-D003': 'ERR_ORGANIZATION_DELETE_EXIST_PARTNER',
  'DGA-D004': 'ERR_ORGANIZATION_DELETE_EXIST_USER',
  'ADB-P001': 'ERR_LOGIN',
  'ADB-P002': 'ERR_ACCOUNT_LOCK',
  'BAE-G001': 'ERR_GET_SAVE_FOLDER',
  'BBB-D001': 'ERR_IMAGE_FOLDER_NOT_FOUND',
  'AEC-P001': 'ERR_RMA_NOT_FOUND',
  'AEC-P002': 'ERR_RMA_STATUS_INCORRECT',
  'AFA-P001': 'ERR_RMA_NOT_FOUND',
  'AFA-P002': 'ERR_EXFM_TYPE_INCORRECT',
  'DJA-U001': 'ERR_ITEM_MODEL_PUT_NOT_FOUND',
  'DJA-U002': 'ERR_ITEM_MODEL_PUT_UNAUTHORIZED',
  'DJA-P001': 'ERR_ITEM_MODEL_POST_EXIST',
  'DJA-P002': 'ERR_ITEM_MODEL_POST_UNAUTHORIZED',
  'DJA-P003': 'ERR_ITEM_MODEL_POST_UNAUTHORIZED',
  'DJA-D001': 'ERR_ITEM_MODEL_DELETE_NOT_FOUND',
  'DJA-D002': 'ERR_ITEM_MODEL_DELETE_UNAUTHORIZED',
  'DKA-G001': 'ERR_ORGANIZATION_BELONG_NOT_FOUND',
  'DNA-G001': 'ERR_TEMPLATE_NOT_FOUND',
  'DNA-G002': 'ERR_REPORT_INCORRECT_INSPECTION_ITEM',
  'BCA-U001': 'ERR_RMA_NOT_FOUND',
  'BCA-U002': 'ERR_RMA_ORGANIZATION_NOT_FOUND',
  'AFA-P003': 'ERR_RMA_ORGANIZATION_NOT_FOUND',
  'AAA-D001': 'ERR_RMA_NOT_FOUND',
  'AAA-D002': 'ERR_RMA_DELETE_UNAUTHORIZED',
  'AGA-P001': 'ERR_RMA_NOT_FOUND',
  'DDA-G001': 'ERR_ATTRIBUTE_NOT_FOUND',
  'DDA-P003': 'ERR_ATTRIBUTE_NOT_FOUND',

  // 予期せぬエラー
  'ZZZ-Z': 'ERR_UNEXPECTED',
};
